module.exports = __webpack_public_path__ + "img/francesca-scozzari.12c37326.jpg";